import { Button, Dropdown, Flex, MenuProps, Typography } from 'antd';
import { FC } from 'react';
import { ExclamationTriangleFill, PencilSquare, ThreeDotsVertical, Trash } from 'react-bootstrap-icons';

import { AppModal } from '@/common/components';
import { useAppModalControls } from '@/common/hooks';

interface Props {
  isItemsDisabled: boolean;
  isDeleteReferralLoading: boolean;
  handleEditReferral: () => void;
  handleDeleteReferral: () => void;
}

export const ReferralsOverviewDropdown: FC<Props> = ({
  isItemsDisabled,
  isDeleteReferralLoading,
  handleEditReferral,
  handleDeleteReferral
}) => {
  const [modalControls] = useAppModalControls();

  const items: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <PencilSquare/>,
      label: 'Редагувати',
      disabled: isItemsDisabled,
      onClick: handleEditReferral,
    },
    {
      key: 'divider',
      type: 'divider',
    },
    {
      key: 'delete',
      disabled: isItemsDisabled,
      danger: true,
      icon: <Trash/>,
      onClick: modalControls.open,
      label: 'Видалити',
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} placement="bottomRight" arrow={{ pointAtCenter: true }} trigger={ ['click'] }>
        <Button icon={ <ThreeDotsVertical/> }/>
      </Dropdown>

      <AppModal
        width={ 400 }
        okText="Видалити"
        okButtonProps={{ danger: true, loading: isDeleteReferralLoading }}
        cancelButtonProps={{ disabled: isDeleteReferralLoading }}
        onOk={ handleDeleteReferral }
        maskClosable={ !isDeleteReferralLoading }
        title={
          <Flex align="center">
            <Typography.Text type="danger">
              <Flex align="center">
                <ExclamationTriangleFill size={ 24 }/>
              </Flex>
            </Typography.Text>&nbsp;&nbsp;&nbsp;Видалити реферал
          </Flex>
        }
        controls={ modalControls }
        closable={ false }
      />
    </>
  );
};
